// FIELDS USED IN inArguments for event Type Webinar
export const fieldNames = {
  webinarConnectionId: "webinarConnectionId",
  webinarId: "webinarId",
  occurrenceId: "occurrenceId",
  registrationUrl: "registrationUrl",
  webinarConnectionLabel: "oceinvitees.webinars.webinarConnection",
  webinarNameLabel: "oceinvitees.webinars.webinarName",
  webinarOccurrenceDateTimeLabel: "oceinvitees.webinars.occurrenceDateTime",
};

// Feature Flags used in application.
export const featureFlags = {
  WEBINARS: "Webinars",
};
